export default {
  hero_title: 'С возвращением!',
  hero_subtitle: 'Держи лицо к солнцу, и тени останутся позади.',
  title: 'Вход в личный кабинет Estimator24',
  subtitle: 'Введите ваши данные для продолжения.',
  email: 'Электронная почта',
  password: 'Пароль',
  remember_me: 'Запомнить меня',
  submit: 'Войти',
  register_link: 'Создать учетную запись'
}
